<template>
  <div>
    <Filtros
      class="mb-5"
      empresas
      colaborador
      funcoes
      indicadores
      action
      @filter="getFilters"
      @input:colaborador="nomeColaborador = $event"
      @change:empresa="
        relatorio.id_empresa = $event.map(empresa => empresa.id_empresa)
      "
      @change:funcao="
        relatorio.id_funcao = $event.map(funcao => funcao.id_funcao)
      "
      @change:indicador="
        relatorio.id_indicador = $event.map(indicador => indicador.id_indicador)
      "
    >
      <RelatorioXlsx :filter="{ ...relatorio }" meta />
    </Filtros>
    <BaseTable
      :headers="headers"
      :items="metas.data"
      :loading="metas.loading"
      :paginate="true"
      :search="nomeColaborador"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Metas</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
        </v-toolbar>
      </template>

      <template v-slot:[`item.colaborador`]="{ item }">
        {{ item.id_colaborador }} - {{ item.colaborador | TitleCase }}
      </template>

      <template v-slot:[`item.funcao`]="{ item }">
        {{ item.funcao | TitleCase }}
      </template>

      <template v-slot:[`item.indicador`]="{ item }">
        {{ item.id_indicador }} - {{ item.indicador }}
      </template>

      <template v-slot:[`item.perc_cresc`]="{ item }">
        {{ item.perc_cresc }}%
      </template>

      <template v-slot:[`item.data_inicio`]="{ item }">
        {{ item.data_inicio | BrazilianStandardDate }}
      </template>

      <template v-slot:[`item.data_final`]="{ item }">
        {{ item.data_final | BrazilianStandardDate }}
      </template>

      <template v-slot:[`item.data_proc`]="{ item }">
        {{ item.data_proc | BrazilianStandardDateAndTime }}
      </template>
    </BaseTable>
  </div>
</template>

<script>
import BaseTable from "@/components/shared/NewBaseTable";
import RelatorioXlsx from "../RelatorioXlsx";
import dateMixin from "@/mixins/dateMixin";
import { mapGetters, mapActions } from "vuex";
import Filtros from "./Filtros";

export default {
  name: "meta-empresa",

  props: {
    idTipoMeta: {
      type: Number
    }
  },

  mixins: [dateMixin],

  components: {
    Filtros,
    BaseTable,
    RelatorioXlsx
  },

  data() {
    return {
      headers: [
        {
          text: "Apelido",
          value: "apelido",
          sortable: true
        },
        { text: "Colaborador", value: "colaborador" },
        { text: "Função", value: "funcao", sortable: true },
        { text: "Indicador", value: "indicador" },
        {
          text: "Meta Gmr",
          value: "meta_gmr",
          align: "right",
          sortable: true
        },
        {
          text: "Meta Campanha",
          value: "meta_campanha",
          align: "right",
          sortable: true
        },
        {
          text: "% Crescimento",
          value: "perc_cresc",
          align: "right",
          sortable: true
        },
        {
          text: "Data Inicial",
          value: "data_inicio"
        },
        {
          text: "Data Final",
          value: "data_final"
        },
        {
          text: "Data de Processamento",
          value: "data_proc",
          sortable: true
        }
      ],
      metas: {
        loading: false,
        total: 0,
        lastPage: 1,
        options: {
          page: 1,
          perPage: 15
        },
        data: []
      },
      filter: false,
      filters: {
        id_empresa: "",
        id_funcao: "",
        id_indicador: ""
      },
      nomeColaborador: "",
      relatorio: {
        id_empresa: "",
        id_tipo_meta: this.idTipoMeta,
        id_funcao: "",
        id_indicador: ""
      }
    };
  },

  async mounted() {
    this.buscaMetaEmpresas();
    this.fetchIndicadores({ per_page: -1, ativa_campanha: "S" });
  },
  computed: {
    ...mapGetters({
      getCurrentCampanha: "campanha/getCurrentCampanha",
      getMetaEmpresa: "campanha/getMetaEmpresa"
    })
  },

  methods: {
    ...mapActions({
      fetchMetaEmpresa: "campanha/fetchMetaEmpresa",
      fetchIndicadores: "campanha/fetchIndicadores"
    }),

    async buscaMetaEmpresas() {
      this.metas.loading = true;
      try {
        await this.fetchMetaEmpresa({
          id_tipo_meta: 4,
          id_campanha: this.getCurrentCampanha,
          per_page: -1
        });

        this.metas.data = this.getMetaEmpresa.data.sort(
          (a, b) => new Date(a.data_inicio) - new Date(b.data_inicio)
        );
        this.metas.total = this.getMetaEmpresa.total;
        this.metas.lastPage = this.getMetaEmpresa.last_page;
      } catch (error) {
        this.$notify({
          type: "error",
          text: "Não foi possivel buscar os dados"
        });

        this.metas.loading = false;
      } finally {
        this.metas.loading = false;
      }
    },

    getFilters(data) {
      const { empresas, filter, funcoes, indicadores } = data;
      this.metas.options.page = 1;
      this.filter = filter;

      this.filters = {
        id_empresa: empresas,
        id_funcao: funcoes,
        id_indicador: indicadores
      };

      this.getMetasFiltradas();
    },

    async getMetasFiltradas() {
      this.metas.loading = true;

      try {
        await this.fetchMetaEmpresa({
          id_tipo_meta: 4,
          id_campanha: this.getCurrentCampanha,
          per_page: -1,
          ...this.filters
        });

        this.metas.data = this.getMetaEmpresa.data;
        this.metas.total = this.getMetaEmpresa.total;
        this.metas.lastPage = this.getMetaEmpresa.last_page;
      } catch (error) {
        this.$notify({
          type: "error",
          text: "Não foi possivel buscar os dados"
        });
        this.metas.loading = false;
      } finally {
        this.metas.loading = false;
      }
    }
  }
};
</script>

<style></style>
